export default "__VITE_ASSET__ddafface__"